<ng-container *transloco="let t">
  <!-- WITH PRODUCT -->

  @if (product && price) {
    <section class="product-installment-options popsy-card">
      <div class="question" (click)="isCollapsed = !isCollapsed">
        <div class="flex flex-col">
          <span class="bold">{{ t('label_installment_plan') }}!</span>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="line fill-row"></span>
          <span class="fixed-space-4" aria-hidden="true"></span>
          <div class="flex flex-row justify-start align-center flex-wrap gap-8">
            @if (product.country === 'SA' && showWataniyaPromo) {
              <popsy-wataniya-badge [size]="'default'" />
            }

            @if (product.country === 'SA' && showTamamPromo) {
              <popsy-tamam-badge [size]="'small'" aria-hidden="true" />
            }

            <popsy-tabby-badge [size]="'medium'" />

            <popsy-tamara-badge [size]="'medium'" />

            <!--  @if (product.country === 'SA') {
              <popsy-quara-badge [size]="'medium'" />
            } -->

            @if (product?.country === 'SA') {
              <popsy-icon-alrajhi-logo
                class="icon"
                [ngClass]="'medium'"
                aria-hidden="true" />
            }

            @if (product.country === 'SA') {
              @if (showBaseetaPromo) {
                <popsy-baseeta-badge [size]="'medium'" />
              }
            }
          </div>
        </div>
        <span class="fixed-space-8" aria-hidden="true"></span>
        <popsy-icon-chevron-down
          class="icon fill-gray-01 p-16"
          [class.selected]="!isCollapsed" />
      </div>

      <!-- COLPASED OPTIONS -->
      <div class="answer" [class.selected]="!isCollapsed">
        <span class="line fill-row"></span>

        @if (product.country === 'SA' && showWataniyaPromo) {
          <div class="option">
            <popsy-wataniya-promo
              [amount]="price?.amount"
              [currency]="product?.price?.currency"
              [country]="product?.country"
              source="product"
              mode="compact" />
          </div>

          <span class="line fill-row"></span>
        }

        @if (product.country === 'SA' && showTamamPromo) {
          <div class="option">
            <popsy-tamam-promo
              [amount]="price?.amount"
              [currency]="product?.price?.currency"
              [country]="product?.country"
              source="product"
              mode="compact" />
          </div>

          <span class="line fill-row"></span>
        }

        <!-- //Tabby card -->
        <div class="option">
          <div class="popsy-card card flex-row position-relative">
            <div class="flex flex-col flex-wrap align-start">
              <div class="flex flex-wrap gap-4">
                <span class="small">{{ t('label_pay_as_low') }}</span>
                <span class="small bold"> {{ tamaraInstallmentPrice | amount }}</span>
                <span class="small"
                  >{{ t('label_n_installments', { var1: installmentsCount }) }}
                </span>
              </div>
              <span class="small underlined">{{ t('action_learn_more') }} </span>
            </div>
            <div class="flex align-center justify-between">
              <span class="dynamic-space" aria-hidden="true"></span>
              <popsy-tabby-badge [size]="'default'" />
            </div>
            <div class="hidden-container">
              <popsy-tabby-promo
                class="hidden-element"
                [amount]="price?.amount"
                [currency]="product?.price?.currency"
                source="product" />
            </div>
          </div>
        </div>
        <span class="line fill-row"></span>

        <!-- Tamara card -->
        <div class="option">
          <div class="popsy-card card position-relative">
            <div class="flex align-center justify-between">
              <div class="flex align-base flex-wrap desc">
                <span class="small">{{
                  t('label_tamara_instalments', { var1: installmentsCount })
                }}</span>
                <span class="fixed-space-4" aria-hidden="true"></span>
                <span class="small bold"> {{ tamaraInstallmentPrice | amount }}/mo</span>
                <span class="fixed-space-4" aria-hidden="true"></span>-
                <span class="fixed-space-4" aria-hidden="true"></span>
                <span class="small">{{ t('label_tamara_instalments_2') }}</span>
              </div>
              <span class="dynamic-space" aria-hidden="true"></span>
              <popsy-tamara-badge [size]="'default'" />
            </div>
            <div class="flex align-center justify-between">
              <span class="small">{{ t('sub_label_tamara_instalments') }}</span>
            </div>
            <span class="small underlined">{{ t('action_learn_more') }} </span>

            <div class="hidden-container">
              <popsy-tamara-summary
                class="hidden-element"
                [productId]="product?.id"
                [amount]="price?.amount"
                [currency]="product?.price?.currency"
                [country]="product?.country"
                source="product" />
            </div>
          </div>
        </div>

        <!--  <span class="line fill-row"></span>

        @if (product.country === 'SA') {
          <div class="option">
            <popsy-quara-promo
              [amount]="price?.amount"
              [currency]="product?.price?.currency"
              [country]="product?.country"
              source="product"
              mode="compact"></popsy-quara-promo>
          </div>

          <span class="line fill-row"></span>
        } -->

        @if (product?.country === 'SA') {
          <div class="option">
            <popsy-alrajhi-promo
              [amount]="price?.amount"
              [currency]="price?.currency"
              [country]="product?.country"
              source="product"
              mode="compact" />
          </div>
          <span class="line fill-row"></span>
        }

        @if (product.country === 'SA') {
          @if (showBaseetaPromo) {
            <div class="option">
              <popsy-baseeta-promo
                [amount]="price?.amount"
                [currency]="product?.price?.currency"
                [country]="product?.country"
                source="product"
                mode="compact"></popsy-baseeta-promo>
            </div>
            <span class="line fill-row"></span>
          }
        }
      </div>
    </section>
  }
</ng-container>
